import React from 'react';
import { Card, Grid, Typography, useMediaQuery } from '@mui/material';
import { injectIntl } from 'react-intl';
import GuidanceButton from './GuidanceButton/GuidanceButton';

const CardStyle = {
  padding: 12
};

const ButtonsGridStyle = {
  flexGrow: 1
};

const ButtonHeightStyle = {
  padding: '6px 6px'
};

const TypoStyle = {
  whiteSpace: 'nowrap',
  color: '#8069ff'
};

const GuidanceGroup = props => {
  const { intl, items } = props;
  const isWide = useMediaQuery(theme => theme.breakpoints.up('sm'));

  return (
    <Card style={CardStyle}>
      <Grid
        container
        spacing={2}
        wrap="nowrap"
        style={{ width: '100%' }}
        sx={{
          alignItems: 'center'
        }}
      >
        <Grid>
          <Grid container spacing={1} sx={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <Grid>
              <img src="img/icons/guidance_demo_active_color.svg" alt="guidance" width={isWide ? 48 : 38} />
            </Grid>
            <Grid>
              <Typography color="primary" style={TypoStyle}>
                {intl.formatMessage({ id: 'quick-demo' })}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid size="grow">
          <Grid
            container
            spacing={0}
            style={{ width: '100%' }}
            sx={{
              justifyContent: 'center'
            }}
          >
            {items.map((item, index) => (
              <Grid key={index} size={12} style={ButtonHeightStyle}>
                <GuidanceButton color="#8069ff" {...item} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

export default injectIntl(GuidanceGroup);
